/* eslint-disable @typescript-eslint/naming-convention */
import { cva } from "class-variance-authority";

export const rootStyles = cva(
  [
    "flex size-max items-center justify-center gap-1.5 border text-center transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-hidden",
    "box-border font-semibold whitespace-nowrap",
  ],
  {
    variants: {
      variant: {
        blank: "",
        "light-dark": "border-neutral-90 bg-neutral-95 text-neutral-30",
        "light-primary": "border-primary-90 bg-primary-95 text-primary-40",
        "light-error": "border-error-90 bg-error-95 text-error-50",
        "light-warning": "border-warning-90 bg-warning-95 text-warning-70",
        "light-success": "border-success-95 bg-success-98 text-success-50",
        "light-blue-gray": "border-neutral-variant-90 bg-neutral-variant-95 text-neutral-variant-30",
        "light-blue": "border-tertiary-90 bg-tertiary-95 text-tertiary-40",
        "light-pink": "border-custom-dark-pink/40 bg-custom-dark-pink/20 text-custom-dark-pink",
        "light-brown": "border-custom-dark-brown/40 bg-custom-dark-brown/20 text-custom-dark-brown",
        "light-yellow": "border-custom-dark-yellow/40 bg-custom-dark-yellow/20 text-custom-dark-yellow",

        "light-green": "border-success-95 bg-custom-light-green text-custom-dark-green",
        "light-custom-green": "border-success-50 bg-success-99 text-success-40",
        "light-red": "border-red-95 bg-custom-light-red text-custom-dark-red",
        "light-orange": "border-orange-95 bg-custom-light-orange text-custom-dark-orange",
        "light-violet": "border-custom-dark-violet/40 bg-custom-light-violet/20 text-custom-dark-violet",

        "solid-dark": "border-neutral-30 bg-neutral-30 text-white",
        "solid-primary": "border-primary-50 bg-primary-50 text-white",
        "solid-error": "border-error-50 bg-error-50 text-white",
        "solid-warning": "border-warning-70 bg-warning-70 text-white",
        "solid-success": "border-success-70 bg-success-70 text-white",
        "solid-blue-gray": "border-neutral-50 bg-neutral-50 text-white",
        "solid-secondary": "border-secondary-50 bg-secondary-50 text-white",
        "solid-tertiary": "border-tertiary-50 bg-tertiary-50 text-white",
        "solid-carrot": "border-custom-dark-orange bg-custom-dark-orange text-white",
        "solid-deep-sea": "border-custom-dark-violet bg-custom-dark-violet text-white",

        "modern-blue": "bg-opacity-20 border-custom-dark-blue bg-custom-dark-blue text-custom-dark-blue",
        "modern-green": "bg-opacity-20 border-custom-dark-green bg-custom-dark-green text-custom-dark-green",

        "outline-success": "border-neutral-90 bg-transparent text-success-50",
        "outline-primary": "border-neutral-90 bg-transparent text-primary-40",
        "outline-tertiary": "border-neutral-90 bg-transparent text-tertiary-60",
        "outline-neutral": "border-neutral-90 bg-transparent text-neutral-60",
        "outline-warning": "border-neutral-90 bg-transparent text-warning-70",
      },
      size: {
        sm: "h-5 px-2",
        md: "h-6 px-2.5",
        lg: "h-7 px-3",
      },
      shape: {
        rounded: "rounded-full",
        square: "rounded",
      },
    },
    defaultVariants: {
      variant: "light-dark",
      size: "sm",
      shape: "rounded",
    },
  }
);

export const labelStyles = cva("text-inherit", {
  variants: {
    size: {
      sm: "text-xs leading-4.5",
      md: "text-sm leading-6",
      lg: "text-sm leading-7",
    },
    variant: {
      blank: "",
      "light-dark": "",
      "light-primary": "",
      "light-error": "",
      "light-warning": "",
      "light-success": "",
      "light-blue-gray": "",
      "light-blue": "",
      "light-pink": "",
      "light-brown": "",
      "light-custom-green": "",
      "light-yellow": "",
      "light-green": "",
      "light-red": "",
      "light-orange": "",
      "light-violet": "",
      "solid-dark": "",
      "solid-primary": "",
      "solid-error": "",
      "solid-warning": "",
      "solid-success": "",
      "solid-blue-gray": "",
      "solid-secondary": "",
      "solid-tertiary": "",
      "solid-carrot": "",
      "solid-deep-sea": "",
      "modern-blue": "",
      "modern-green": "",
      "outline-success": "text-neutral-10",
      "outline-primary": "text-neutral-10",
      "outline-tertiary": "text-neutral-10",
      "outline-neutral": "text-neutral-10",
      "outline-warning": "text-neutral-10",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export const iconStyles = cva("shrink-0", {
  variants: {
    size: {
      xs: "size-1.5",
      sm: "size-3",
      md: "size-4",
      lg: "size-5",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});
